import { LitElement, TemplateResult, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("ml-mini-game")
export class MLMiniGame extends LitElement {
    public static styles = css`
        h1 {
            color: orange;
        }

        .gameHeader {
            text-align: center;
        }

        .gameRect {
            background-color: steelblue;
            width: 60rem;
        }

        .correctAnswerDisplay {
            text-align: center;
            border: 2px solid purple;
            padding: 0.5rem;
            background-color: blue;
        }

        .selectionsDisplay {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            cursor: pointer;
        }

        .selectionsDisplay > div {
            background-color: purple;
            color: white;
            border: 2px solid orange;
            padding: 1rem;
        }

        .selectionsDisplay > div:hover {
            background-color: white;
            color: purple;
        }
    `;

    private questions: { [key: string]: { tr: string; en: string } } = {
        "1": { tr: "Kral", en: "King" },
        "2": { tr: "Kraliçe", en: "Queen" },
        "3": { tr: "Köy", en: "Village" },
        "4": { tr: "Kilise", en: "Church" },
        "5": { tr: "Kuşatma", en: "Siege" },
        "6": { tr: "Orman", en: "Forest" },
        "7": { tr: "Kılıç", en: "Sword" },
        "8": { tr: "Zırh", en: "Armor" },
        "9": { tr: "Ok", en: "Arrow" },
        "10": { tr: "Şövalye", en: "Knight" },
        "11": { tr: "Kule", en: "Tower" },
        "12": { tr: "Ejderha", en: "Dragon" },
        "13": { tr: "Saray", en: "Palace" },
        "14": { tr: "Prens", en: "Prince" },
        "15": { tr: "Prenses", en: "Princess" },
        "16": { tr: "Kapı", en: "Gate" },
        "17": { tr: "Kervan", en: "Caravan" },
        "18": { tr: "Hazine", en: "Treasure" },
        "19": { tr: "Savaş", en: "War" },
        "20": { tr: "Barış", en: "Peace" },
        "21": { tr: "Gizem", en: "Mystery" },
        "22": { tr: "Macera", en: "Adventure" },
        "23": { tr: "Büyü", en: "Magic" },
        "24": { tr: "Cadı", en: "Witch" },
        "25": { tr: "Elf", en: "Elf" },
        "26": { tr: "Cüce", en: "Dwarf" },
        "27": { tr: "Troll", en: "Troll" },
        "28": { tr: "Efsane", en: "Legend" },
        "29": { tr: "Destan", en: "Epic" },
        "30": { tr: "Yaratık", en: "Creature" },
    };

    private dummyData: string[] = [
        "castle",
        "kingdom",
        "queen",
        "river",
        "scroll",
        "dagger",
        "jewel",
        "map",
        "wizard",
        "potion",
        "peasant",
        "royalty",
        "medieval",
        "tavern",
        "feast",
        "squire",
        "herald",
        "banner",
        "mystic",
        "spell"
    ];
    private correctAnswer?: { tr: string; en: string };
    private displayArray: string[] = [];
    private selectedByPlayer?: string;
    private score: number = 0;

    public connectedCallback(): void {
        super.connectedCallback();
        void this.startGame();
    }

    public render(): TemplateResult {
        return html` ${this.score < 5 ? html`<div class="gameRect">${this.renderGame()}</div>` : null} `;
    }

    public renderGame(): TemplateResult {
        return html`
            ${this.renderGameHeader()} ${this.renderCorrectAnswerInTr()} ${this.renderScore()}
            <div class="selectionsDisplay">
                ${this.displayArray.map(
                    (item) => html`<div @click=${(): void => this.selectByUserHandle(item)}>${item}</div>`
                )}
            </div>
        `;
    }

    private renderScore(): TemplateResult {
        return html`<div class="correctAnswerDisplay">
            <h5>Score:</h5>
            ${this.score}
        </div>`;
    }

    private selectByUserHandle(item: string): void {
        this.selectedByPlayer !== item ? (this.selectedByPlayer = item) : null;
        console.log("sectigim", item === this.correctAnswer?.en);
        if (item === this.correctAnswer?.en) {
            this.score += 1;
            this.resetState();
            this.requestUpdate();
        } else {
            this.score = 0;
            this.resetState();
            this.requestUpdate();
        }
    }

    //random soru secici
    private selectRandomItemFromQuestionData(): { tr: string; en: string } {
        const keys: string[] = Object.keys(this.questions);

        const randomItem: string = keys[Math.floor(Math.random() * keys.length)];
        console.log(randomItem);

        this.correctAnswer = this.questions[randomItem];

        console.log(this.correctAnswer);

        return this.correctAnswer;
    }

    // random dummy data secici
    private selectTwoRandomDummyData(array: string[]): string[] {
        const copyArray: string[] = [...this.dummyData];

        const randomIndex: number = Math.floor(Math.random() * copyArray.length);
        array.push(copyArray[randomIndex]);
        copyArray.splice(randomIndex, 1);

        const randomIndex2: number = Math.floor(Math.random() * copyArray.length);
        array.push(copyArray[randomIndex2]);
        copyArray.splice(randomIndex2, 1);

        return array;
    }

    // arrayi karistir
    private shuffleArray(array: string[]): string[] {
        for (let i: number = array.length - 1; i > 0; i--) {
            const j: number = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    // game header
    private renderGameHeader(): TemplateResult {
        return html`<h1 class="gameHeader">Magic Language Resolve</h1>`;
    }

    // dogru cevabi goster
    private renderCorrectAnswerInTr(): TemplateResult {
        return html`${this.correctAnswer
            ? html`<h3>Magic word</h3>
                  <h3 class="correctAnswerDisplay">${this.correctAnswer?.tr}</h3>`
            : null}`;
    }

    private displayArraySetUp(): string[] {
        const dumArray: string[] = [];

        this.selectTwoRandomDummyData(dumArray);

        if (this.correctAnswer) {
            dumArray.push(this.correctAnswer.en);
        }

        this.shuffleArray(dumArray);

        return dumArray;
    }

    private startGame(): void {
        this.correctAnswer = this.selectRandomItemFromQuestionData();

        this.displayArray = this.displayArraySetUp();

        console.log(this.correctAnswer);
    }

    private resetState(): void {
        if (this.correctAnswer && this.displayArray && this.selectedByPlayer) {
            this.correctAnswer = undefined;
            this.displayArray = [];
            this.selectedByPlayer = undefined;
        }

        this.startGame();
    }
}
